'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
var initial = {
  fetching: false,
  error: false,
  actionTaken: ''
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.RESET_MTA:
      return initial;
    case _constants.actionTypes.SUBMIT_MTA + '_' + _reduxPromiseMiddleware.PENDING:
      return {
        fetching: true,
        error: false,
        actionTaken: ''
      };
    case _constants.actionTypes.SUBMIT_MTA + '_' + _reduxPromiseMiddleware.REJECTED:
      return {
        fetching: false,
        error: true,
        actionTaken: ''
      };
    case _constants.actionTypes.SUBMIT_MTA + '_' + _reduxPromiseMiddleware.FULFILLED:
      return {
        fetching: false,
        error: false,
        actionTaken: action.payload.data.data.actionTaken
      };
    case _constants.actionTypes.CLEAR_MTA:
      return initial;
    default:
      return state;
  }
};